var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTabletFondoGracias(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1024,
    height: 1366,
    viewBox: "0 0 1024 1366",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1366,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-453.643 -449.284)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 7.62,
    transform: "translate(1082.686 1720.473)",
    fill: "none",
    stroke: "#e4e2db",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 7.62,
    transform: "translate(1086.496 1716.663)",
    fill: "none",
    stroke: "#e4e2db",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x2: 5.189,
    y2: 5.58,
    transform: "translate(1083.901 1717.683)",
    fill: "none",
    stroke: "#e4e2db",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 5.189,
    x2: 5.58,
    transform: "translate(1083.706 1717.879)",
    fill: "none",
    stroke: "#e4e2db",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(792.608 961.465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1024.349,2715.038c37.343,4.856,70.043,29.51,76.3,67.266,4.5,27.156-1.088,42.7-11.153,54.7-15.45,18.42-41.791,27.717-56.195,58.556-23.535,50.384,57.1,100.925,87.547,42.52",
    transform: "translate(1209.041 -2608.128)",
    fill: "none",
    stroke: "#eddb45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.001
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1247.771,2667.372c13.058-47,63.679-100.69,112.569-75.008s69.176,73.612,65.43,121.853-38.958,95.239-80.411,71.111c-18.806-10.948-18.7-40.694-5.125-57.7a103.227,103.227,0,0,1,79.182-35.888",
    transform: "translate(1247.771 -2585.708)",
    fill: "none",
    stroke: "#eddb45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.001
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280.145 230.973) rotate(161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.568,2809.868a96.069,96.069,0,0,0,6.165,11.636c44.218,73.678-11.576,155.6-103.574,117.423-81.933-34-13.816-150.6,58.716-142.487,121.662,4.6,168.117,172.967,88.476,254.94",
    transform: "translate(-83.822 -2671.245)",
    fill: "none",
    stroke: "#eddb45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.726,2926.463c53.854-80.457,60.808-234.623-41.669-277.583-71.757-21.11-127.209,49.588-114.39,114.518",
    transform: "translate(-110.344 -2645.076)",
    fill: "none",
    stroke: "#eddb45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.178,2814.6",
    transform: "translate(-112.313 -2674.462)",
    fill: "none",
    stroke: "#eddb45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.921, 0.391, -0.391, 0.921, 3.885, 1084.534)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 113.989,
    transform: "translate(0 56.994)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    y1: 113.989,
    transform: "translate(56.994 0)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    x2: 77.627,
    y2: 83.472,
    transform: "translate(18.181 15.258)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    y1: 77.627,
    x2: 83.472,
    transform: "translate(15.258 18.181)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(773.234 246.787)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 38.749,
    transform: "translate(0 19.374)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 38.749,
    transform: "translate(19.374)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x2: 26.388,
    y2: 28.375,
    transform: "translate(6.18 5.187)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 26.388,
    x2: 28.375,
    transform: "translate(5.187 6.18)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-856.643 -1590.966)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 68.302,
    transform: "translate(1082.686 1750.814)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 68.302,
    transform: "translate(1116.837 1716.663)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x2: 46.514,
    y2: 50.017,
    transform: "translate(1093.58 1725.806)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 46.514,
    x2: 50.017,
    transform: "translate(1091.829 1727.557)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-542.643 -1687.283)",
    opacity: 0.579
  }, /*#__PURE__*/React.createElement("line", {
    x2: 7.62,
    transform: "translate(1082.686 1720.473)",
    fill: "none",
    stroke: "#20201d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 7.62,
    transform: "translate(1086.496 1716.663)",
    fill: "none",
    stroke: "#20201d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x2: 5.189,
    y2: 5.58,
    transform: "translate(1083.901 1717.683)",
    fill: "none",
    stroke: "#20201d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 5.189,
    x2: 5.58,
    transform: "translate(1083.706 1717.879)",
    fill: "none",
    stroke: "#20201d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-58.686 -1093.163)",
    opacity: 0.579
  }, /*#__PURE__*/React.createElement("line", {
    x2: 7.62,
    transform: "translate(1082.686 1720.473)",
    fill: "none",
    stroke: "#20201d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 7.62,
    transform: "translate(1086.496 1716.663)",
    fill: "none",
    stroke: "#20201d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x2: 5.189,
    y2: 5.58,
    transform: "translate(1083.901 1717.683)",
    fill: "none",
    stroke: "#20201d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 5.189,
    x2: 5.58,
    transform: "translate(1083.706 1717.879)",
    fill: "none",
    stroke: "#20201d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-521.686 -771.955)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 33.513,
    transform: "translate(1082.686 1733.42)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 33.513,
    transform: "translate(1099.443 1716.663)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x2: 22.823,
    y2: 24.541,
    transform: "translate(1088.031 1721.149)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 22.823,
    x2: 24.541,
    transform: "translate(1087.172 1722.009)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-396.686 -976.178)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 0.271,
    transform: "translate(1082.686 1716.799)",
    fill: "none",
    stroke: "#20201d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 0.271,
    transform: "translate(1082.822 1716.663)",
    fill: "none",
    stroke: "#20201d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x2: 0.185,
    y2: 0.199,
    transform: "translate(1082.729 1716.7)",
    fill: "none",
    stroke: "#20201d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 0.185,
    x2: 0.199,
    transform: "translate(1082.722 1716.707)",
    fill: "none",
    stroke: "#20201d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-764.686 -1335.43)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 7.62,
    transform: "translate(1082.686 1720.473)",
    fill: "none",
    stroke: "#e4e2db",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 7.62,
    transform: "translate(1086.496 1716.663)",
    fill: "none",
    stroke: "#e4e2db",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x2: 5.189,
    y2: 5.58,
    transform: "translate(1083.901 1717.683)",
    fill: "none",
    stroke: "#e4e2db",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 5.189,
    x2: 5.58,
    transform: "translate(1083.706 1717.879)",
    fill: "none",
    stroke: "#e4e2db",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-930.643 -867.284)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 7.62,
    transform: "translate(1082.686 1720.473)",
    fill: "none",
    stroke: "#e4e2db",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 7.62,
    transform: "translate(1086.496 1716.663)",
    fill: "none",
    stroke: "#e4e2db",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x2: 5.189,
    y2: 5.58,
    transform: "translate(1083.901 1717.683)",
    fill: "none",
    stroke: "#e4e2db",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 5.189,
    x2: 5.58,
    transform: "translate(1083.706 1717.879)",
    fill: "none",
    stroke: "#e4e2db",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-977.684 -441.664)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 7.62,
    transform: "translate(1082.686 1720.473)",
    fill: "none",
    stroke: "#e4e2db",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 7.62,
    transform: "translate(1086.496 1716.663)",
    fill: "none",
    stroke: "#e4e2db",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x2: 5.189,
    y2: 5.58,
    transform: "translate(1083.901 1717.683)",
    fill: "none",
    stroke: "#e4e2db",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 5.189,
    x2: 5.58,
    transform: "translate(1083.706 1717.879)",
    fill: "none",
    stroke: "#e4e2db",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletFondoGracias);
export default __webpack_public_path__ + "static/media/tablet_fondo_gracias.75ffd45e778a82c35a88e13c6cb9ae40.svg";
export { ForwardRef as ReactComponent };